import _ from "lodash";
import { PhoneInfoForm, PhoneDTO } from "../domain/models/dto/PhoneDTO";
import { PhoneService } from "../domain/services/PhoneService";

class PhoneServiceImpl implements PhoneService {
    checkDuplicates(phones: PhoneDTO[] | PhoneInfoForm[]): boolean {
        const modelsWithPhone = phones.filter((item) => item.phone);
        return (
            _.uniqBy(modelsWithPhone, "phone").length !== modelsWithPhone.length
        );
    }
}

export default function phoneServiceFactory(): PhoneService {
    return new PhoneServiceImpl();
}
